<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router'
import { SellerSizeGuidesFullQuery } from '@gql/SellerSizeGuidesFullQuery'
import { SellerSizeGuidesQuery } from '@gql/SellerSizeGuidesQuery'

const t2 = useT2({
  'Size guides': 'Dydžių lentelės',
})

const { rewrite } = useLinks()
const mobile = useMobile()
const locale = useLocale()
const sellerId = useSellerId('retail')

const variables = computed((): gen.SellerSizeGuidesFullQueryVariables | undefined => {
  const id = sellerId.value
  if (!id) return
  return { input: { cursor: { number: 1, size: 40 }, get: 'Items' as const }, sellerId: id }
})

const { ui: itemsDesktop } = useApolloWrap2<gen.SellerSizeGuidesFullQuery, gen.SellerSizeGuidesFullQueryVariables>(SellerSizeGuidesFullQuery)({
  vars: () => (mobile.value ? undefined : variables.value),
  ui: (i) => i?.publicSizeGuides?.items,
})
const { ui: itemsMobile } = useApolloWrap2<gen.SellerSizeGuidesQuery, gen.SellerSizeGuidesQueryVariables>(SellerSizeGuidesQuery)({
  vars: () => (mobile.value ? variables.value : undefined),
  ui: (i) => i?.publicSizeGuides?.items,
})

function escapeId(id: string) {
  // If starts with a number, escape it
  return id.replace(/^\d/, '\\3$&')
}
function toLink(guide: gen.SellerSizeGuideFragment): RouteLocationRaw {
  return rewrite({ name: 'info-size-guides', hash: `#${escapeId(guide._id)}` }, locale.value)
}
</script>

<template>
  <AppMenu :title="t2('Size guides')" max class-main="d_pl3 d_pr3 m_pb140">
    <!-- <DevLink to="https://www.mercari.com/us/help_center/product-info/mens-size-guide/" />
    <DevLink to="https://www.meandem.com/cheesecloth-shirred-crop-top-black/" />
    <DevLink to="https://www.everlane.com/products/mens-track-pant-blue/" />
    <DevLink to="https://faithfullthebrand.com/products/aires-one-piece-joscana-print/" />
    <DevLink to="https://www.intimissimi.com/lt/product-guide-textiles.html/" />
    <DevLink to="https://zozo.jp/shop/sizeguide.html#2001/" />
    <DevLink to="https://www.massimodutti.com/lt/techninio-audinio-lietpaltis-l03418236/" />
    <DevLink to="https://shop.reigningchamp.com/products/deltapeak-90-training-tank-black/" />
    <DevLink
      to="https://www.acnestudios.com/eu/en/hooded-ripstop-puffer-jacket-dark-khaki-multi/B90644-CSJ.html?cgid=man-outerwear/"
    />
    -->

    <template v-if="mobile">
      <InfoBoxes v-slot="{ item, exit }" :items="itemsMobile" :ui="(i) => ({ key: i._id, img: i.image, title: i.title.value, hasContent: true })">
        <LazySizeGuide4Mobile :guide-product-id="item._id" :guide-body-id="undefined" :seller-id :exit />
      </InfoBoxes>
    </template>
    <template v-else>
      <InfoBoxes :items="itemsDesktop" :ui="(i) => ({ key: i._id, img: i.image, title: i.title.value, to: toLink(i) })" />
      <SizeGuide4Table v-for="guide in itemsDesktop" :key="guide._id" :guide :hash="escapeId(guide._id)" />
    </template>
  </AppMenu>
</template>
